import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiErrorResponse } from './api-error.model';
import { extractApiError } from './api-error.util';

/**
 * Normalizes any HttpErrorResponse into a canonical ApiError shape and attaches it to
 * the original HttpErrorResponse instance as `apiError`.
 *
 * This keeps backwards compatibility with existing code that expects HttpErrorResponse,
 * while enabling NGXS/UI to consume a stable error model.
 */
export const apiErrorInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    return next(req).pipe(
        catchError((err: ApiErrorResponse) => {
            if (err instanceof HttpErrorResponse) {
                const apiError = extractApiError(err);
                err.apiError = apiError;
                // Log server/network errors in a controlled way (no response body)
                if (err.status === 0 || (err.status >= 500 && err.status < 600)) {
                    console.warn('[Radiopharm] API error', {
                        status: err.status,
                        code: apiError?.code,
                        url: err.url,
                    });
                }
            }
            return throwError(() => err);
        })
    );
};
